import ShopDTO from "@/dto/shop/ShopDTO";
import { observer } from "mobx-react-lite";
import React from "react";
import ShippingDeadlineCalculator from "./ShippingDeadlineCalculator";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { showDeadlineShippingOrderTabs } from "@/utils/OrderTabUtil";

interface ShippingDeadlineColumnProps {
    shop: ShopDTO;
    shippingDeadline: string;
    tab: OrderTab;
}

const ShippingDeadlineColumn: React.FC<ShippingDeadlineColumnProps> = function ({ shop, shippingDeadline, tab }) {
    return (
        <td>
            <ShippingDeadlineCalculator
                shop={shop}
                shippingDeadline={shippingDeadline}
                showCountdown={showDeadlineShippingOrderTabs.includes(tab)}
            />
        </td>
    );
};

export default observer(ShippingDeadlineColumn);
